module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Bold.8050f5f3.woff";